import debounce from 'lodash/debounce'
import votingRoundStore from "../stores/votingRoundStore"
import seasonStore from "../stores/seasonStore"

const DEBOUNCE_DELAY = 4000 // 4 seconds

const handleNewVoteEvent = () => {
  if (!seasonStore.selectedSeasonId) return
  votingRoundStore.fetchVotingRounds(seasonStore.selectedSeasonId)
}

const handleVotingRoundStartedEvent = () => {
  if (!seasonStore.selectedSeasonId) return
  votingRoundStore.fetchVotingRounds(seasonStore.selectedSeasonId)
}

const handleVotingRoundEndedEvent = () => {
  if (!seasonStore.selectedSeasonId) return
  votingRoundStore.fetchVotingRounds(seasonStore.selectedSeasonId)
}

// Create debounced versions of the handlers
const debouncedHandleNewVoteEvent = debounce(handleNewVoteEvent, DEBOUNCE_DELAY)
const debouncedHandleVotingRoundStartedEvent = debounce(handleVotingRoundStartedEvent, DEBOUNCE_DELAY)
const debouncedHandleVotingRoundEndedEvent = debounce(handleVotingRoundEndedEvent, DEBOUNCE_DELAY)

export const handleEvent = (payload: any) => {
  switch (payload?.event?.title) {
    case "new_vote_event":
      return debouncedHandleNewVoteEvent()
    case "voting_round_started":
      return debouncedHandleVotingRoundStartedEvent()
    case "voting_round_ended":
      return debouncedHandleVotingRoundEndedEvent()
    default:
      console.log('unknown event', payload)
      return
  }
}